import OpenAI from 'openai';

// OpenAI API 키 - 환경변수나 하드코딩
const apiKey = import.meta.env.VITE_OPENAI_API_KEY;

console.log('OpenAI API Key 존재:', !!apiKey);

if (!apiKey) {
  console.error('OpenAI API 키가 설정되지 않았습니다.');
}

const openai = new OpenAI({
  apiKey: apiKey,
  dangerouslyAllowBrowser: true // 브라우저에서 직접 호출을 위해 필요
});

export async function generateBusinessGuide(businessData) {
  try {
    console.log('비즈니스 가이드 생성 시작:', businessData);

    const prompt = `
당신은 쿠팡, 무신사, 마켓컬리, 토스, 배달의민족 등 한국 스타트업 성공 사례를 직접 컨설팅한 20년 경력의 비즈니스 실무 전문가입니다.
책상머리 이론이 아닌 한국 시장에서 실제 검증된 전략만을 제공합니다.

**고객 개별 맞춤 정보:**
- 업종: ${businessData.industry || '미지정'}
- 현재 단계: ${businessData.stage || '미지정'}
- 사업 지역: ${businessData.location || '미지정'}
- 타겟 고객: ${businessData.target || '미지정'}
- 초기 예산: ${businessData.budget || '미지정'}
- 현재 상황: ${businessData.current_situation || '미지정'}
- 보유 강점: ${businessData.unique_advantage || '미지정'}
- 구체적 목표: ${businessData.specific_goal || '미지정'}
- 희망 기간: ${businessData.timeline || '미지정'}
- 경쟁 상황: ${businessData.competition || '미지정'}
- 핵심 고민: ${businessData.concerns || '미지정'}

**개인 맞춤 분석 규칙 (CO-STAR 기반):**
1. Context: ${businessData.location || '해당 지역'}의 ${businessData.industry || '해당 업종'} 시장 상황을 정확한 수치로 분석
2. Objective: "${businessData.specific_goal || '목표'}"를 ${businessData.timeline || '설정 기간'} 내 달성하는 구체적 방법 제시
3. Style: "${businessData.current_situation || '현재 상황'}"을 고려한 단계별 실행 지침
4. Tone: "${businessData.concerns || '고민 사항'}"에 대한 현실적 해결책과 구체적 해법 제시
5. Audience: "${businessData.unique_advantage || '보유 강점'}"을 최대한 활용할 수 있는 맞춤형 가이드
6. Response: ${businessData.competition || '경쟁 상황'}을 고려한 차별화 전략과 실행 방안

## 🎯 개인 맞춤 사업기회 분석

### 당신만의 강점 활용 전략
**보유 강점 "${businessData.unique_advantage || '강점'}" 분석:**
- **강점 활용도**: 이 강점이 ${businessData.industry || '해당 업종'}에서 어떻게 차별화 요소가 되는지 구체적 분석
- **수익화 방안**: 보유 강점을 직접 수익으로 연결하는 3가지 구체적 방법
- **강점 강화**: 현재 강점을 더욱 발전시켜 경쟁 우위를 확보하는 실행 계획

### ${businessData.location || '해당 지역'} 지역 특화 분석
- **지역 시장 규모**: ${businessData.location || '해당 지역'}의 ${businessData.industry || '해당 업종'} 시장 규모와 성장률
- **지역 특성 활용**: 이 지역만의 특징을 활용한 비즈니스 차별화 방안
- **지역 네트워크**: 지역 내 활용 가능한 네트워크, 커뮤니티, 협력 업체 발굴 방법

### "${businessData.current_situation || '현재 상황'}" 맞춤 전략
- **상황별 장점**: 현재 상황에서만 가능한 독특한 비즈니스 기회 3가지
- **리스크 관리**: 현재 상황에서 발생할 수 있는 위험 요소와 대응 방안
- **자원 최적화**: 제한된 자원으로 최대 효과를 내는 구체적 실행 전략

### 수익성 전망
- **목표 매출**: 1년차 현실적 월매출 목표 금액과 구체적 달성 방법
- **손익분기점**: 정확한 월 필요매출 금액과 예상 달성 시기(N개월차)
- **현금흐름**: 1~6개월차 각각의 예상 수입/지출 금액 명시

## 📊 "${businessData.target || '타겟 고객'}" 맞춤 분석

### 당신의 타겟 고객 심층 분석
**"${businessData.target || '타겟 고객'}" 프로파일:**
- **${businessData.location || '지역'} 내 고객 특성**: 이 지역 "${businessData.target || '타겟층'}"의 구체적 소비 패턴과 선호도
- **구매력 분석**: ${businessData.location || '해당 지역'} "${businessData.target || '타겟층'}"의 월 평균 소비 금액과 소비 성향
- **접점 발굴**: 이들이 가장 많이 이용하는 온라인/오프라인 채널과 시간대 분석

### "${businessData.competition || '경쟁 상황'}" 기반 차별화 전략
- **경쟁사 약점 공략**: 언급하신 경쟁 상황에서 경쟁사들이 놓치고 있는 틈새 시장 3가지
- **나만의 포지셔닝**: 경쟁사와 차별화되는 독특한 브랜드 포지셔닝과 메시지
- **경쟁 우위 확보**: "${businessData.unique_advantage || '보유 강점'}"을 활용한 압도적 경쟁 우위 창출 방법

### "${businessData.concerns || '핵심 고민'}" 완벽 해결책

**고민 해결 로드맵:**
- **즉시 해결 가능**: 언급하신 고민 중 오늘 당장 시작할 수 있는 해결책 3가지
- **1개월 내 해결**: 체계적 접근으로 1개월 내 완전히 해결할 수 있는 방법
- **장기 예방책**: 같은 문제가 재발하지 않도록 하는 시스템 구축 방안

### "${businessData.specific_goal || '목표'}" ${businessData.timeline || '기간'} 달성 전략
- **주간 체크포인트**: 매주 달성해야 할 구체적 수치와 행동 지표
- **월간 마일스톤**: 매월 확인할 핵심 성과 지표와 조정 방안
- **성공 확률 높이기**: 목표 달성 확률을 80% 이상으로 높이는 5가지 전략

## 💡 차별화 및 포지셔닝 전략
### 경쟁우위 확보
- **유일한 강점**: [경쟁사가 따라하기 어려운 3가지 차별점]
- **가격 전략**: [프리미엄/적정/저가 중 최적 포지션과 근거]
- **서비스 차별화**: [고객이 "여기서만 받을 수 있다"고 느끼는 요소]

### 브랜딩 실행법
- **브랜드 메시지**: [10초 안에 기억되는 핵심 메시지]
- **온라인 존재감**: [SNS/홈페이지/블로그 콘텐츠 전략]
- **오프라인 브랜딩**: [매장/명함/포장재 등 브랜드 경험 설계]

## 🚀 "${businessData.specific_goal || '목표'}" ${businessData.timeline || '기간'} 달성 맞춤 실행계획

### "${businessData.current_situation || '현재 상황'}" 최적화 1주차
**"${businessData.unique_advantage || '보유 강점'}" 활용 집중 준비:**
**월요일 오전**: ${businessData.location || '해당 지역'} 상권 분석, "${businessData.target || '타겟 고객'}" 집중 지역 3곳 선정
**월요일 오후**: "${businessData.competition || '경쟁 상황'}" 정밀 분석, 경쟁사별 약점과 기회 요소 파악
**화요일**: 보유 강점 "${businessData.unique_advantage || '강점'}"을 활용한 차별화 상품/서비스 기획
**수요일**: ${businessData.location || '지역'} 특화 마케팅 채널 발굴, 지역 커뮤니티 가입 5곳
**목요일**: "${businessData.concerns || '고민'}" 해결을 위한 구체적 액션플랜 수립과 첫 실행
**금요일**: 첫 주 성과 측정, 다음 주 전략 수정 및 보완

### 2주차 (고객접촉 시작)
- **고객 발굴**: [매일 신규 고객 N명 접촉하는 구체적 방법]
- **세일즈 시스템**: [상담→제안→계약 프로세스 구축]
- **품질 관리**: [서비스/제품 품질 체크리스트 작성]

### 3주차 (매출 발생)
- **첫 매출 달성**: [목표 금액과 달성 전략]
- **고객 만족도**: [CS 시스템 구축과 피드백 수집]
- **개선 사이클**: [주간 성과 리뷰와 개선점 도출]

### 4주차 (최적화 및 확장)
- **운영 효율화**: [시간/비용 절약 포인트 3가지]
- **확장 준비**: [2개월차 목표와 필요 투자/인력]
- **시스템 구축**: [재현가능한 성공 패턴 문서화]

## 💰 정밀 예산계획
### 초기 투자 (상세 내역)
1. **필수 투자** (${businessData.budget ? `${businessData.budget} 기준` : '예산별'}):
   - **플랫폼/도구비**: 카페24(월 25,000원), 메이크샵(월 30,000원), 고도몰(월 35,000원) 중 선택
   - **마케팅 툴**: 페이스북 비즈니스 관리자(무료), 인스타그램 광고(일 1만원부터), 구글 애널리틱스(무료)
   - **디자인 툴**: 캔바 프로(월 12,000원), 어도비 포토샵(월 24,000원), 무료 대안: GIMP
   - **고객관리**: 카카오톡 채널(무료), 네이버 스마트스토어(수수료 2.8%), 챗봇: 채널톡(월 39,000원)
   - **배송 연동**: 로젠택배(기본요금 2,500원), CJ대한통운(2,800원), 한진택배(2,600원)

2. **월 운영비** (손익분기 기준):
   - [고정비/변동비 세분화]
   - [비용 절약 포인트 5가지]
   - [매출 증가시 추가 비용 예측]

### 수익 예측 (현실적 시나리오)
- **보수적 시나리오**: [월매출 최소 목표]
- **일반적 시나리오**: [월매출 평균 목표]
- **낙관적 시나리오**: [월매출 최대 목표]

## ⚠️ 실패 방지 가이드
### 99% 실패하는 이유 TOP 5
1. [업종별 가장 흔한 실패 원인과 예방법]
2. [자금 부족으로 인한 실패와 현금관리법]
3. [고객 부족으로 인한 실패와 마케팅 필수사항]
4. [품질 문제로 인한 실패와 QC 체크포인트]
5. [운영 미숙으로 인한 실패와 시스템 구축법]

### 위기 대응 매뉴얼
- **매출 급감시**: [즉시 실행할 3가지 대응책]
- **경쟁사 공격시**: [차별화 강화 방법]
- **자금 부족시**: [비상 자금 확보 방법 5가지]

## 🎯 당신만의 성공 공식

**맞춤형 요약:**
"${businessData.current_situation || '현재 상황'}"에서 "${businessData.unique_advantage || '보유 강점'}"을 활용하여 ${businessData.location || '해당 지역'} "${businessData.target || '타겟 고객'}"에게 차별화된 가치를 제공한다면, "${businessData.specific_goal || '목표'}"를 ${businessData.timeline || '설정 기간'} 내 달성할 수 있습니다.

**핵심 성공 키워드:**
1. **강점 극대화**: "${businessData.unique_advantage || '보유 강점'}"
2. **지역 특화**: ${businessData.location || '해당 지역'} 맞춤 전략
3. **고민 해결**: "${businessData.concerns || '핵심 고민'}" 완벽 극복
4. **목표 달성**: "${businessData.specific_goal || '구체적 목표'}" 실현

**즉시 시작할 액션 아이템:**
1. 오늘: "${businessData.concerns || '고민'}" 해결 첫 번째 단계 실행
2. 이번 주: "${businessData.unique_advantage || '강점'}" 활용한 차별화 요소 구체화
3. 이번 달: ${businessData.location || '지역'} 타겟 고객 100명 접촉 시작

**중요**: 이 가이드는 ${businessData.industry || '해당 업종'}, ${businessData.location || '지역'}, "${businessData.current_situation || '상황'}", "${businessData.unique_advantage || '강점'}"을 종합 분석한 완전 맞춤형 전략입니다.
`;

    const response = await openai.chat.completions.create({
      model: 'gpt-3.5-turbo',  // 토큰 제한이 더 넉넉한 모델로 변경
      messages: [
        {
          role: 'system',
          content: `# CONTEXT (배경)
당신은 한국 스타트업 생태계에서 20년간 활동한 비즈니스 실무 전문가입니다.
- 쿠팡(창업→유니콘), 무신사(10억→1조 매출), 토스(0→500만 MAU) 성장 과정 직접 자문
- 실패한 스타트업 300개 이상 분석, 성공 패턴 데이터베이스 보유
- 현재 2025년 한국 시장 최신 트렌드와 규제 완벽 숙지

# OBJECTIVE (목적)
입력받은 비즈니스 정보를 분석하여, 내일 당장 실행 가능한 초구체적 실무 가이드를 생성합니다.
성공 목표: 사용자가 가이드를 보고 즉시 행동할 수 있을 정도의 구체성

# STYLE (스타일)
- 말투: 단호하고 직설적 (예: "~해야 합니다" "반드시 ~하세요")
- 수치: 모든 금액은 원 단위까지 정확히 (예: 2,847,000원)
- 예시: 실제 한국 업체명, 실제 상품명, 실제 가격 사용
- 금지어: "약", "대략", "정도", "~것 같습니다", "[대괄호]"

# TONE (톤)
- 전문가의 확신: 20년 경험에서 나오는 단호함
- 현실적 경고: 실패 가능성도 직설적으로 언급
- 동기부여: "당신도 할 수 있다"가 아닌 "이렇게 하면 된다"

# AUDIENCE (청중)
- 비즈니스 초보자: 사업자등록증도 없는 완전 초보
- 실행력 부족: 아이디어만 있고 실행 경험 전무
- 예산 제약: 대부분 1,000만원 이하 소자본 창업

# RESPONSE (응답 형식)
반드시 아래 규칙을 100% 준수:
1. 모든 금액은 정확한 숫자 (예: 월매출 2,850만원, 객단가 48,500원)
2. 모든 업체는 실명 (예: 쿠팡, 네이버, 카카오, 무신사, 지그재그)
3. 모든 일정은 시간 포함 (예: 월요일 오전 9시-11시, 화요일 오후 2시-4시)
4. 모든 도구는 가격 명시 (예: 카페24 월 33,000원, 캔바 프로 월 14,300원)
5. 절대 [대괄호] 플레이스홀더 사용 금지
6. 한국 시장/서비스만 언급 (해외 서비스 언급 시 한국 대안 제시)`
        },
        {
          role: 'user',
          content: prompt
        }
      ],
      max_tokens: 2000,  // 토큰 제한을 줄여서 에러 방지
      temperature: 0.6
    });

    const text = response.choices[0].message.content;
    console.log('생성된 가이드 길이:', text.length);
    return text;
  } catch (error) {
    console.error('OpenAI API 오류:', error);
    console.error('오류 상세:', error.message, error.stack);

    if (error.message?.includes('API key')) {
      throw new Error('API 키가 유효하지 않습니다. 관리자에게 문의하세요.');
    } else if (error.message?.includes('quota')) {
      throw new Error('API 사용량을 초과했습니다. 잠시 후 다시 시도해주세요.');
    } else if (error.message?.includes('rate limit')) {
      throw new Error('요청이 너무 많습니다. 잠시 후 다시 시도해주세요.');
    } else {
      throw new Error(`가이드 생성에 실패했습니다: ${error.message}`);
    }
  }
}

export async function analyzeMarket(industry) {
  try {
    const prompt = `
${industry} 업종의 시장 분석을 해주세요.

다음 정보를 포함해주세요:
- 시장 규모 및 성장률
- 주요 트렌드
- 경쟁사 현황
- 기회 요소
- 위험 요소

간결하고 실용적인 정보로 작성해주세요.
`;

    const response = await openai.chat.completions.create({
      model: 'gpt-3.5-turbo',  // 토큰 제한이 더 넉넉한 모델로 변경
      messages: [
        {
          role: 'system',
          content: '당신은 시장 분석 전문가입니다. 정확하고 실용적인 시장 정보를 제공합니다.'
        },
        {
          role: 'user',
          content: prompt
        }
      ],
      max_tokens: 1000,
      temperature: 0.7
    });

    return response.choices[0].message.content;
  } catch (error) {
    console.error('시장 분석 오류:', error);
    throw new Error('시장 분석에 실패했습니다.');
  }
}